import React, { useState, useRef } from "react";
import {
  Container,
  FontName,
  InputConatiner,
  FontDetaiSubTitle,
  FontInput,
  FontView,
  BottomButton,
  FontInfoTabList,
  FontInfoTab,
  TopButton,
  PPTButton,
  FontPreview,
  StoryView,
  FontPreviewName,
  ButtonBox,
  BrushPreview,
  FontNameContainer,
  IconChiness,
  FontContainer,
  FontInfoContainer,
  StoryMainImage,
  MoreStoryImage,
  StoryImageItem,
  StoryShowMore,
  FontStroyInnerTitle,
  Concept,
} from "./style";

import {
  RangeBox,
  FontSizeValue,
  sizeStyle,
  FontSize,
  MinFontSize,
  MaxFontSize,
} from "../Detail/style";

import FontBox from "components/FontBox";

import { Link, Navigate } from "react-router-dom";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FontInfo from "components/FontInfo";

import topButton from "resources/topButton.png";
import btnAngleDown from "resources/btnAngleDown.png";
import btnAngleUp from "resources/btnAngleUp.png";

import { Slider, Space, Row, Col } from "antd";

const useRangeInput = (defaultValue, min, max, step) => {
  const [value, setValue] = useState(defaultValue);
  const onInput = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);
  };

  return { value, onInput, min, max, step };
};

const useFontInput = (defaultValue, setPreview) => {
  const [value, setValue] = useState(defaultValue);
  const onChange = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);
    setPreview(value);
  };
  return { value, onChange };
};

const useExpandBtn = (expandRef) => {
  const [expand, setExpand] = useState(false);
  const onClick = () => {
    if (!expand) {
      expandRef.current.style.maxHeight = `${15000}px`;
    } else {
      expandRef.current.style.maxHeight = `${0}px`;
    }
    setExpand(!expand);
  };

  return { expand, onClick };
};

const DetailPresenter = ({ loading, detail, info, story, related }) => {
  const containerRef = useRef();
  const moreStoryRef = useRef();
  // const { goBack } = useNavigate();
  const FontType = {
    TTF: "TTF",
    OTF: "OTF",
    OTFPro: "OTF Pro",
  };
  const range = useRangeInput(52, 12, 100, 1);
  const [tabSelect, setTabSelect] = useState(FontType.TTF);
  const [previewText, setPreviewText] = useState(
    "언제 어디서나 클라우드 폰트 서비스"
  );
  const fontInput = useFontInput("", setPreviewText);
  const expandStoryBtn = useExpandBtn(moreStoryRef);

  // console.log(related);

  const gotoTop = () => window.scrollTo(0, 0);

  const saveImage = () => {
    window.print();
    // window.scrollTo(0,0)
    // html2canvas(containerRef.current).then(canvas => {
    //     var a = document.createElement('a');
    //     a.href = canvas.toDataURL("image/jpeg");
    //     a.download = `${detail.familyname}.jpg`;
    //     a.click();
    // })
  };

  const goToBottom = () => {
    let scrollHeight = document.documentElement.scrollHeight;
    let currentScroll = window.pageYOffset + 936;
    let currentPosition = (currentScroll / scrollHeight) * 100;

    if (currentPosition > 90) {
      console.log(scrollHeight, currentScroll)
      console.log("바닥이다!!" + currentPosition)
      window.scrollTo(0, document.body.scrollHeight);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: currentScroll, behavior: "smooth" });
    }
  };

  const subTitle = (index) => {
    switch (index) {
      case 1:
        return "";
      case 2:
        return "";
      case 3:
        return "";
      default:
        return "";
    }
  };

  const isBrush = detail?.familyname.includes("Brush");

  let sample = "서체명";
  let sampleSize = 38;

  // 폰트 사이즈 적용

  const [inputValue, setInputValue] = useState(55);
  const onChange = (newValue) => {
    console.log(newValue);
    setInputValue(newValue);
  };

  const formatter = (value) => `${value}px`;

  let sizeStyle = {
    // left: `${60 + (parseInt(range.value) - 34) * 1.45}px`,
    left: `${60 + (parseInt(inputValue) - 34) * 1.45}px`,
  };

  let fontSizeStyle = {
    //fontSize: `${range.value}px`,
    fontSize: `${inputValue}px`,
  };

  return (
    <Container ref={containerRef} id="containerRef">
      <FontNameContainer>
        <FontName webFontName={detail?.webfontname} brush={isBrush}>
          {detail?.familyname}
        </FontName>
      </FontNameContainer>

      <FontNameContainer>
        <Concept>{detail?.concept}</Concept>
      </FontNameContainer>

      <FontInfoContainer>
        <InputConatiner data-html2canvas-ignore="true" className="no-print">
          <FontInput
            type="text"
            {...fontInput}
            placeholder={
              isBrush
                ? "미리보기 텍스트는 500자 만 지원합니다."
                : "원하는 글자를 입력하세요."
            }
          />
          <RangeBox>
            <div style={{ width: "200px" }}>
              <Row>
                <Col flex="auto">
                  <Slider
                    defaultValue={55}
                    tooltipVisible={true}
                    onChange={onChange}
                    tipFormatter={formatter}
                    min={10}
                    max={100}
                  />
                </Col>
              </Row>
            </div>
            {/* <FontSizeValue style={sizeStyle}>{range.value}</FontSizeValue>
            <MinFontSize>A</MinFontSize>
            <FontSize type="range" {...range} readOnly />
            <MaxFontSize>A</MaxFontSize> */}
          </RangeBox>

          <></>
        </InputConatiner>
        {/* <FontInfoTabList align={"flex-start"}>
        {detail?.format.split(",").map((format, index) => (
          <FontInfoTab
            key={`format_${index}`}
            onClick={() => setTabSelect(format)}
            selected={tabSelect === format ? true : false}
          >
            {format === "PRO" ? "OTF Pro" : format}
          </FontInfoTab>
        ))}
      </FontInfoTabList> */}

        {/* 서체리스트 */}
        <FontView>
          {info?.map((f, index) => {
            // console.log(f);
            return (
              <div key={`fontView${index}`}>
                <FontPreviewName>
                  {" "}
                  {f.kor} {f.hanja === 1 ? <IconChiness /> : ""}{" "}
                </FontPreviewName>
                {/* <FontPreview 
                                    value={isBrush ? "ABCDEFGHIJKLMNOPQRSTUVWXYZ" : previewText}
                                    disabled 
                                    style={fontSizeStyle} 
                                    webfontname={tabSelect !== FontType.TTF ? `${f.webfontname}_${tabSelect}` : f.webfontname}/> */}
                <FontPreview
                  value={isBrush ? "ABCDEFGHIJKLMNOPQRSTUVWXYZ" : previewText}
                  disabled
                  style={fontSizeStyle}
                  webfontname={f.webfontname}
                />
              </div>
            );
          })}
        </FontView>
        {story?.length !== 0 && (
          <StoryView>
            <FontDetaiSubTitle>스토리 보기</FontDetaiSubTitle>
            {story?.map((story, index) => {
              if (index === 0) {
                return (
                  <StoryMainImage
                    key={`story${index}`}
                    url={`http://font.fontbada.co.kr/images/stories/${story.family}_${story.types}.png`}
                  />
                );
              }
            })}
            <MoreStoryImage ref={moreStoryRef}>
              {story?.map((story, index) => {
                if (index !== 0) {
                  let text = [];
                  text.push(
                    <FontStroyInnerTitle key={`storymore_${index}`}>
                      {subTitle(index)}
                    </FontStroyInnerTitle>
                  );
                  // if (story.count === 1) {
                  //   text.push(
                  //     <StoryImageItem key={`storymore${index}`}>
                  //       <img
                  //         src={`http://font.fontbada.co.kr/images/stories/${story.family}_${story.types}.png`}
                  //         alt=""
                  //       />
                  //     </StoryImageItem>
                  //   );
                  //   return text;
                  // } else {
                  for (let i = 0; i < story.count; i++) {
                    text.push(
                      <StoryImageItem key={`storymore${index}_${i}`}>
                        <img
                          src={`http://font.fontbada.co.kr/images/stories/${story.family
                            }_${story.types}_${i + 1}.png`}
                          alt=""
                        />
                      </StoryImageItem>
                    );
                  }
                  return text;
                  //}
                }
              })}
            </MoreStoryImage>
            {/* <StoryShowMore
              onClick={expandStoryBtn.onClick}
              expand={expandStoryBtn.expand}
              img={expandStoryBtn.expand ? btnAngleUp : btnAngleDown}
            /> */}
          </StoryView>
        )}
        <FontInfo detail={detail} info={info} />
      </FontInfoContainer>
      {/* 관련서체 */}

      <FontContainer ref={containerRef}>
        {related?.map((f, index) => {
          // if ((index+1)%28 === 0){
          //     doc.addPage();
          // }

          const text = (
            <FontBox
              key={f.idx}
              id={f.idx}
              type={f.types}
              webfont={f.webfontname}
              familyname={f.familyname}
              isNew={f.is_new}
              font={f}
              family_type={f.family_type}
              sampleText={sample}
              sampleSize={sampleSize}
            />
          );
          return text;
        })}
      </FontContainer>
      {/* <ButtonBox data-html2canvas-ignore="true" className="no-print">
        <BottomButton onClick={goBack}>← 이전 페이지로 가기</BottomButton>
        <BottomButton onClick={saveImage}>화면출력 하기</BottomButton>

        <Link to="/docs/all">
          <PPTButton />
        </Link>
        <TopButton onClick={gotoTop} />
      </ButtonBox> */}
    </Container>
  );
};

export default DetailPresenter;
